module.exports = __webpack_public_path__ + "static/media/ljy.38d4e88a.png";